// extracted by mini-css-extract-plugin
module.exports = {"preserveSpace":"ErrorBoundry-m__preserveSpace___z5Kwe","error":"ErrorBoundry-m__error___ptsAA","fullScreen":"ErrorBoundry-m__fullScreen___S3aHi"};